<template>
  <div style="display:flex;flex-direction: column;min-height: 100vh;">
    <div class="head" style="padding-top: 24rem;">
      <img style="display: block; width:200rem; height:50rem;padding-left: 375rem;padding-right: 180rem;" src="../assets/zsp/logo.png">
      <div v-for="(item, index) in titleName" :key="index" style="font-size: 24rem;height:40rem;padding-left:50rem;" @click="pageId=index">
        <div v-if="index == pageId">
          <div style="color:#3a7fb6;">{{ item }}</div>
          <div style="margin-top:20rem;height:4rem;background:#3a7fb6;"></div>
        </div>
        <div v-else style="color: #444444;opacity: 0.7;">{{ item }}</div>
      </div>
      <div v-if="userID.length > 0" class="horizontal" style="margin-left: 520rem;font-size: 15rem;">
        <div>{{ userName }}</div>
        <div style="text-align: center;margin-left: 10rem;background: #eeeeee;padding: 5rem 10rem;border-radius: 5rem;" @click="exit">退出</div>

        <div class="horizontal" style="margin-left:10rem;background:#f9f3e7;padding:5rem 10rem;border-radius: 5rem;" @click="showBuyPanel = true">
          <img style="display: block;width: 20rem;padding-right: 5rem;" src="../assets/zsp/gold.png">
          <div>{{ aiMoney }} AI币</div>
        </div>
      </div>
    </div>

    <div style="flex: 1;margin-top:80rem;">
      <div style="width:1920rem;height:5rem;background: #f4f4f4;"></div>
      <div v-if="pageId == 0"><PageModelHub :userID="userID" @updateMoney="updateMoney"/></div>
      <div v-if="pageId == 1"><PageMyVideo :userID="userID"/></div>
      <div v-if="pageId == 2"><PageAboutUs/></div>
    </div>

    <div v-if="pageId == 0" style="width:1920rem;height:240rem; background:#f4f4f4;margin-top:50rem;color:#666666;">
      <div class="horizontal" style="padding-left:375rem;padding-top: 48rem;">
        <img style="display: block;width:98rem;height:50rem;" src="../assets/zsp/logo2.png">
        <div style="padding-left:84rem;">
          <div style="font-size:24rem;">联系方式</div>
          <div style="padding-top:20rem;font-size:18rem;opacity: 0.5;">
            电话：18501641153<br>邮箱：47161167@qq.com<br>地址：上海市徐汇区龙华街道:龙耀路175号星扬西岸中心20C
          </div>
          <div style="padding-top:10rem;"><a style="font-size:18rem;" href="https://beian.miit.gov.cn/"
              target="_blank">京ICP备2021039423号-2</a></div>
        </div>
        <div style="padding-left:420rem;">
          <img style="display:block;width:100rem;height:100rem;" src="../assets/tongtu/kefuerweima.png">
          <div style="padding-top:10rem;font-size:14rem;opacity: 0.5;line-height: 16rem;">
            扫描二维码<br>添加客服咨询
          </div>
        </div>
      </div>
    </div>

    <div v-if="userID.length <= 0" class="mask">
      <LogIn @user_info="landing" />
    </div>
    <div v-if="showBuyPanel" class="mask">
      <PayFor :userID="userID" :aiMoney=aiMoney @close="closeBuyPanel" />
    </div>
  </div>
</template>

<script>
import PageModelHub from './PageModelHub.vue'
import PageMyVideo from './PageMyVideo.vue'
import PageAboutUs from './PageAboutUs.vue'
import LogIn from './LogIn.vue'
import PayFor from './PayFor.vue'

export default {
  components: { PageModelHub, PageMyVideo, PageAboutUs, LogIn, PayFor },
  data() {
    return {
      userID: "",
      userName: "",
      pageId: -1,
      aiMoney: 0.0,
      showBuyPanel: false,
      titleName: ["首页", "我的视频", "联系我们"]
    }
  },

  created() {
    console.log("route", window.location.href)
    document.title = ''
    this.getRouterData()
  },

  methods: {
    getRouterData() {
      let userid = localStorage.getItem("user_id")
      let username = localStorage.getItem("user_name")
      if (userid != null && userid.length > 0) {
        this.userID = userid
        this.userName = username
        this.pageId = 0
      }
    },
    exit() {
      this.userID = ""
      this.userName = ""
      this.pageId = -1
      //
      localStorage.removeItem("user_id")
      localStorage.removeItem("user_name")
      localStorage.removeItem("phone_num")
    },
    landing(message) {
      this.userID = "" + message.user_id
      this.userName = message.user_name

      if (this.userID.length > 0) {
        this.pageId = 0
      }
    },
    updateMoney(aiMoney0){
      this.aiMoney = aiMoney0
    },
    closeBuyPanel() {
      this.showBuyPanel = false
    }
  },
}
</script>

<style scoped>
.head {
  flex-direction: row;
  display: flex;
  position:absolute;
  left:0;
  top:0;
  align-items: center;
}

.horizontal {
  flex-direction: row;
  display: flex;
  position: relative;
  align-items: center;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .3);
  z-index: 9999;

  width: 100%;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;
}</style>
